// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2246":"68ab465e","2948":"68ab465e","3964":"68ab465e","4041":"68ab465e","4858":"68ab465e","4945":"68ab465e","6069":"68ab465e","6227":"68ab465e","6321":"68ab465e","8349":"68ab465e","8969":"68ab465e"}[chunkId] + ".chunk.css";
};